// Phase 5.2 — small bidi/RTL helpers for learner-generated content.
// We do NOT mirror the whole UI. We tag only content whose direction depends on the
// language (vocab words, FluentLens output, example sentences, conversation bubbles,
// quiz prompts). `dir="auto"` lets the browser infer direction from the first strong
// character, which correctly handles Arabic/Persian inside an English LTR interface
// and mixed Latin+RTL strings.
import { isRtl } from "@/lib/languages";

// Props to spread onto any element that renders target/native generated text.
// `langCode` is optional; when omitted we rely purely on dir="auto".
export const bidi = (langCode) => ({
  dir: "auto",
  ...(langCode && isRtl(langCode) ? { lang: langCode } : {}),
});

// Inline Bidi text wrapper. Usage: <Bidi code={target}>{word}</Bidi>
export function Bidi({ code, as: Tag = "span", className = "", children, ...rest }) {
  return (
    <Tag dir="auto" {...(code ? { lang: code } : {})} className={className} {...rest}>
      {children}
    </Tag>
  );
}
